import { render } from "./formsView.vue?vue&type=template&id=7eb61a3b&scoped=true"
import script from "./formsView.vue?vue&type=script&lang=js"
export * from "./formsView.vue?vue&type=script&lang=js"

import "./formsView.vue?vue&type=style&index=0&id=7eb61a3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb61a3b"]])

export default __exports__